/**
 * @generated SignedSource<<7b4e3d2d4f005c47f5afc0408163e588>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type JiraAssigneeSelectionType = "ACCOUNT_OWNER" | "ACCOUNT_TAG" | "ACCOUNT_VARIABLE" | "EMAIL" | "RESOURCE_OWNER" | "RESOURCE_TAG" | "%future added value";
export type JiraSpaceSelectionType = "ACCOUNT_TAG" | "ACCOUNT_VARIABLE" | "RESOURCE_TAG" | "SPACE_KEY" | "%future added value";
export type UpdateNotificationRuleInput = {
  description?: string | null | undefined;
  filter?: FilterElementInput | null | undefined;
  groupBy?: ReadonlyArray<string> | null | undefined;
  includeCostData?: boolean | null | undefined;
  jiraTarget?: NotificationRuleJiraTargetInput | null | undefined;
  name?: string | null | undefined;
  updateSchedule?: string | null | undefined;
  uuid: any;
};
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type NotificationRuleJiraTargetInput = {
  assignee?: JiraAssigneeSelectionInput | null | undefined;
  description?: string | null | undefined;
  instanceUUID: any;
  space: JiraSpaceSelectionInput;
  workType: string;
};
export type JiraSpaceSelectionInput = {
  type: JiraSpaceSelectionType;
  value: string;
};
export type JiraAssigneeSelectionInput = {
  type: JiraAssigneeSelectionType;
  value?: string | null | undefined;
};
export type UpdateNotificationRuleMutation$variables = {
  input: UpdateNotificationRuleInput;
};
export type UpdateNotificationRuleMutation$data = {
  readonly updateNotificationRule: {
    readonly notificationRule: {
      readonly description: string | null | undefined;
      readonly filterJSON: string;
      readonly groupBy: ReadonlyArray<string>;
      readonly id: string;
      readonly includeCostData: boolean;
      readonly name: string;
      readonly openGroupCount: number;
      readonly openResourceCount: number;
      readonly target: {
        readonly assignee?: {
          readonly type: JiraAssigneeSelectionType;
          readonly value: string | null | undefined;
        } | null | undefined;
        readonly description?: string | null | undefined;
        readonly instance?: {
          readonly uuid: any;
        } | null | undefined;
        readonly space?: {
          readonly type: JiraSpaceSelectionType;
          readonly value: string;
        };
        readonly workType?: string;
      } | null | undefined;
      readonly updateSchedule: string | null | undefined;
      readonly uuid: any;
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type UpdateNotificationRuleMutation = {
  response: UpdateNotificationRuleMutation$data;
  variables: UpdateNotificationRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterJSON",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupBy",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeCostData",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openGroupCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openResourceCount",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraAssigneeSelection",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": (v10/*:: as any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraSpaceSelection",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": (v10/*:: as any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workType",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updateSchedule",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateNotificationRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateNotificationRulePayload",
        "kind": "LinkedField",
        "name": "updateNotificationRule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationRule",
            "kind": "LinkedField",
            "name": "notificationRule",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "target",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*:: as any*/),
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JiraInstance",
                        "kind": "LinkedField",
                        "name": "instance",
                        "plural": false,
                        "selections": [
                          (v12/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v13/*:: as any*/),
                      (v14/*:: as any*/)
                    ],
                    "type": "NotificationRuleJiraTarget",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v15/*:: as any*/),
              (v12/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v16/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpdateNotificationRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateNotificationRulePayload",
        "kind": "LinkedField",
        "name": "updateNotificationRule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationRule",
            "kind": "LinkedField",
            "name": "notificationRule",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "target",
                "plural": false,
                "selections": [
                  (v17/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*:: as any*/),
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JiraInstance",
                        "kind": "LinkedField",
                        "name": "instance",
                        "plural": false,
                        "selections": [
                          (v12/*:: as any*/),
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v13/*:: as any*/),
                      (v14/*:: as any*/)
                    ],
                    "type": "NotificationRuleJiraTarget",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v15/*:: as any*/),
              (v12/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v17/*:: as any*/),
              (v16/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "39371095dab0f2f1479a0ce2f54a2706",
    "id": null,
    "metadata": {},
    "name": "UpdateNotificationRuleMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateNotificationRuleMutation(\n  $input: UpdateNotificationRuleInput!\n) {\n  updateNotificationRule(input: $input) {\n    notificationRule {\n      description\n      filterJSON\n      groupBy\n      id\n      includeCostData\n      name\n      openGroupCount\n      openResourceCount\n      target {\n        __typename\n        ... on NotificationRuleJiraTarget {\n          assignee {\n            type\n            value\n          }\n          description\n          instance {\n            uuid\n            id\n          }\n          space {\n            type\n            value\n          }\n          workType\n        }\n      }\n      updateSchedule\n      uuid\n    }\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b6e8229813fd16f871b753b4e5b9423e";

export default node;
